/* eslint-disable no-unused-vars */
import { useDispatch, useSelector, } from "react-redux";
import { useContext, useEffect, useState, useRef } from "react"
import useSWR, { useSWRConfig } from "swr"
import _ from 'lodash'

import './style.css'
import * as T from "./styles"

import { NewAddProduct } from "../Modals/Orders/components/NewAddProduct";
import { Card } from "../../pages/Home/components/Card";
import { OffCanvas } from "../OffCanvas";
import { ModalTable } from "./ModalTable";
import { Btn } from "../Btn";
import { CustomItemCard } from "../CustomItemCard";

import { api } from "../../api/api";
import { GlobalContext } from "../../context/GlobalContext";
import { OrderContext } from "../../context/OrderContext";
import { useOffCanvas } from "../../hooks/useOffCanvas";
import { CLEAR_SELECT_ORDER, UPDATE_ORDER } from "../../stores/reducers/OrderReducers";
import { CLEAR_SELECT_TABLE, SELECT_TABLE } from "../../stores/reducers/TableReducers";
import { maskCurrency } from "../../utils/utils";
import { Toast } from "../../utils/Toast";
import { sendPrint } from "../../reporting/print";

import { IoClose } from "react-icons/io5";
import { MdTableRestaurant } from "react-icons/md";
import { FiPlusCircle, FiUserPlus } from "react-icons/fi";
import { BiTable } from "react-icons/bi"
import { FaBoxesStacked, FaRegTrashCan, FaCheck } from "react-icons/fa6";
import { LuCirclePlus, LuPackageCheck, LuPackagePlus } from "react-icons/lu";
import { HiOutlinePrinter } from "react-icons/hi";
import { IoIosArrowForward } from "react-icons/io";
import { BsCreditCard2Back } from "react-icons/bs";
import { CustomerForm } from "../Forms/Customer";
import { AllPayments } from "../Modals/Orders/components/AllPayments";
import { DateTime } from "luxon";
import { TableOffCanvasOrder } from "../OffcanvasOrder/tableOffCanvas";
import { CgDanger } from "react-icons/cg";

let isRequest = false

export function TableComponent({ setCountTables, dataProductsNotSeen }) {
  const dispatch = useDispatch()
  const { isAccess } = useContext(GlobalContext)
  const { orders, selectOrder } = useContext(OrderContext)
  const { isOffCanvasOpen, toggleOffCanvas } = useOffCanvas()

  const dataTables = useSelector(state => state.table.data)
  const selectTable = useSelector(state => state.table.table)
  const order = useSelector(state => state.order.orderSelect)
  const [tableFilter, setTableFilter] = useState('all')

  const { mutate } = useSWRConfig()

  async function openTable(value) {
    dispatch(SELECT_TABLE(value))
  }

  async function createTable() {
    if (!isAccess('mesas', 'criar_mesa')) {
      return Toast.warning('Você não tem permissão para criar mesa');
    }

    const quantity = await Toast.getValue('Digite a quantidade de mesa do seu estabelecimento', null, null, null, 'number')

    if (!quantity) {
      return
    }

    await api.post('/tables', { quantity })
  }

  async function openOrder(command) {
    await selectOrder(command.idOrder)
    await mutate('/product-order/products/not-seen')
  }

  useEffect(() => {
    setCountTables(dataTables.filter(e => Boolean(e.available) === false)?.length ?? 0)
  }, [dataTables, dataTables.length, setCountTables])

  const availableTables = dataTables.filter(table => Boolean(table.available)).length
  const busyTables = dataTables.length - availableTables
  const filteredTables = dataTables.filter(table => {
    if (tableFilter === 'available') return Boolean(table.available)
    if (tableFilter === 'busy') return !Boolean(table.available)
    return true
  })

  return (
    <>
      <ModalTable
        payload={selectTable}
        clear={() => dispatch(CLEAR_SELECT_TABLE())} />

      <div id="container-table" className="tables-panel">
        <div className="tables-panel-header">
          <div className="tables-panel-title">
            <span className="tables-panel-icon"><BiTable size={19} /></span>
            <div>
              <h2>Controle de mesas</h2>
              <p>Selecione uma mesa para visualizar ou iniciar uma comanda</p>
            </div>
          </div>
          {isAccess() !== 'garcom' && (
            <button type="button" className="tables-add-button" onClick={createTable}>
              <FiPlusCircle size={17} /> Adicionar mesas
            </button>
          )}
        </div>

        <div className="tables-toolbar">
          <div className="tables-filters" role="group" aria-label="Filtrar mesas">
            <button type="button" className={tableFilter === 'all' ? 'active' : ''} onClick={() => setTableFilter('all')}>
              Todas <span>{dataTables.length}</span>
            </button>
            <button type="button" className={tableFilter === 'available' ? 'active' : ''} onClick={() => setTableFilter('available')}>
              <i className="table-status-dot available" /> Livres <span>{availableTables}</span>
            </button>
            <button type="button" className={tableFilter === 'busy' ? 'active' : ''} onClick={() => setTableFilter('busy')}>
              <i className="table-status-dot busy" /> Ocupadas <span>{busyTables}</span>
            </button>
          </div>
          <p>{busyTables} {busyTables === 1 ? 'mesa ocupada' : 'mesas ocupadas'}</p>
        </div>

        <div className="container-orders-mesa">
          <div className="tables-grid">
            {_.orderBy(
              filteredTables?.map(t => ({ ...t, name: Number(t.name) })) ?? [],
              "name",
              "asc"
            ).map(value => {
              const isUpdated = _.orderBy(value?.commands, 'cratedAt', 'asc').find(e => (dataProductsNotSeen?.groupedByIdOrder[e.idOrder]?.length ?? 0) > 0)

              return (
                <div key={value.id} className="table-card-wrapper">
                  <div
                    className={`table-card ${value.available ? "available" : "busy"}`}
                    onClick={async () => {
                      await openTable(value);
                      const commandAux = _.orderBy(value?.commands, 'cratedAt', 'asc')[0]
                      if (commandAux)
                        openOrder(commandAux)
                      toggleOffCanvas();
                    }}
                  >
                    <div className="table-content">
                      {isUpdated && (
                        <span className="table-update-alert" title="Esta mesa possui novos itens">
                          <CgDanger size={18} />
                        </span>
                      )}
                      <div className="table-card-topline">
                        <span>Mesa</span>
                        <i className={`table-status-dot ${value.available ? 'available' : 'busy'}`} />
                      </div>
                      <span className="table-number">{value.name}</span>

                      <div className="table-status">
                        {value.available ? (
                          <>
                            <MdTableRestaurant size={17} />
                            <span>Livre</span>
                          </>
                        ) : (
                          <>
                            <IoClose size={18} />
                            <span>Ocupada</span>
                          </>
                        )}
                      </div>
                      {!value.available && (
                        <span className="table-command-count">
                          {value.commands?.length || 0} {value.commands?.length === 1 ? 'comanda' : 'comandas'}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
            {filteredTables.length === 0 && (
              <div className="tables-empty-state">
                <MdTableRestaurant size={28} />
                <strong>Nenhuma mesa encontrada</strong>
                <span>Altere o filtro para visualizar outras mesas.</span>
              </div>
            )}
          </div>
        </div>
      </div >

      <TableOffCanvasOrder
        isOffCanvasOpen={isOffCanvasOpen}
        toggleOffCanvas={toggleOffCanvas}
      />
    </>
  )
}
